module.exports = __webpack_public_path__ + "organic-91c8d.svg";